if (!customElements.get("electricity-content")) {
  customElements.define(
    "electricity-content",
    class ElectricityContent extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll(".electricity-tab");
        this.activeIndex = 0;
        this.swiperTop = this.querySelector("#section-electricity-swiper-top");
        this.swiperBottom = this.querySelector(
          "#section-electricity-swiper-bottom"
        );
        this.updateSlider(0);
        this.init();
      }

      init() {
        const _this = this;

        this.tabs.forEach((item, index) => {
          item.onclick = () => {
            // $(this.tabs).not(item).removeClass("active");
            // item.classList.add("active");
            _this.updateSlider(index);
          };
        });

        this.swiperTop.swiper.on("slideChange", (e) => {
          _this.updateSlider(e.activeIndex);
        });
        $(window).on(
          "resize",
          $.debounce(150, () => this.updateSlider())
        );
      }

      updateSlider(index = this.activeIndex) {
        this.activeIndex = index;
        this.swiperTop.slideTo(index);
        this.swiperBottom.slideTo(index);

        $(this.tabs).not(this.tabs[index]).removeClass("active");
        this.tabs[index].classList.add("active");
        const { offsetLeft, offsetWidth } = this.tabs[index];
        $(this.querySelector(".section-electricity-tabs")).css({
          ["--offsetLeft"]: offsetLeft + "px",
          ["--offsetWidth"]: offsetWidth + "px",
        });
      }
    }
  );
}
